import 'angular';
import '../components/report_result.component';
import template from './search_results.template.html?raw';

angular
  .module('fundingSearchApp.directives.searchResults', [])
  .run(['$templateCache', $templateCache => {
    $templateCache.put(template, template);
  }])
  .directive('searchResults', ['dateFilterService',
    dateFilterService => {

      const link = $scope => {
        $scope.selectResult = result => {
          $scope.$emit('result.selected', result);
        };

        $scope.removableFilters = [
          {text: 'Keywords', key: 'query', icon: 'icon-pencil'},
          {text: 'Region or country', key: 'places', icon: 'icon-map-marker-alt'},
          {text: 'Funders', key: 'donors', icon: 'icon-building'},
          {text: 'Topics', key: 'news_topics', icon: 'icon-globe'},
          {text: 'Time updated', key: 'updated_since', icon: 'icon-clock'}
        ];

        $scope.removeTagHandler = key => {
          if (key === 'updated_since') {
            dateFilterService.setDate('reset', true);
            return;
          }
          $scope.search.filter[key].reset();
          $scope.search.notifyParamChange();
        };
      };

      return {
        restrict: 'E',
        templateUrl: template,
        scope: {
          toggleTrackReport: '=',
          activeReport: '=',
          results: '=',
          userPermissions: '=',
          search: '=',
        },
        link
      };
    }]
  );
